import ErrorDialog, { type ErrorDialogComponentRefType, type ErrorDialogOptions } from "@src/components/apollo/errorprovider/ErrorDialog";
import { type FunctionComponent, type PropsWithChildren, useRef } from "react";

import ErrorContext from "./ErrorContext";

const ErrorProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const errorDialogRef = useRef<ErrorDialogComponentRefType>(null);

    const showError = (options: ErrorDialogOptions) => {
        if (errorDialogRef?.current) {
            errorDialogRef.current?.setError(options);
        }
    };

    return (
        <ErrorContext.Provider value={{ showError }}>
            {children}
            <ErrorDialog ref={errorDialogRef} />
        </ErrorContext.Provider>
    );
};

export default ErrorProvider;
